import React, {useState, useEffect, useContext} from 'react'
import {Link} from 'react-router-dom'

import {ApiServiceContext} from '../context'

import Counter from '../counter'
import withApiService from '../hoc/with-api-service'
import withData from '../hoc/with-data'

const OrderListCard = ({response, id, size, amount, cartId, basket, setBasket, prices, setPrices}) => {
  const {data} = response;
  const apiService = useContext(ApiServiceContext);
  const [count, setCount] = useState(amount);

  let price;
  if (data) {
    price = data.price
  }

  useEffect(() => {
    const newPrices = prices ? [...prices] : [];

    if (price) {
      if (newPrices.some(item => item.id === id && item.size === size)) {
        newPrices.forEach(item => {
          if (item.id === id && item.size === size){
            item.price = price * count;
          }
        })
      } else {
        newPrices.push({
          id: id,
          size: size,
          price: price * count
        });
      }
      setPrices(newPrices)
    }
  }, [price, count]);

  useEffect(() => {
    const purchasing = {
      "id": parseInt(id),
      "size": parseInt(size),
      "amount": count
    };

    apiService.setCart(`${cartId}`, purchasing)
      .then(({data}) => {
        const {products} = data;
        setBasket(products)
      })
      .catch(console.error)
  }, [count]);

  return (
    <div className="basket-item">
      <div className="basket-item__pic"><img src={data && data.images[0]}
                                             alt={data && data.title}/></div>
      <div className="basket-item__product">
        <div className="basket-item__product-name">
          <Link to={`/product-card-desktop/${id}`}>{data && data.title}</Link>
        </div>
        <div className="basket-item__product-features">
          <div className="basket-item__size">Размер: <span>{size}</span></div>
          <div className="basket-item__producer">Производитель: <span>{data && data.brand}</span></div>
          <div className="basket-item__color">Цвет: <span>{data && data.color}</span></div>
        </div>
      </div>
      <Counter order
               count={count}
               setCount={setCount}/>
      <div className="basket-item__price">
        {price && (price * count).toLocaleString('ru-RU')}
        <i className="fa fa-rub" aria-hidden="true"/>
      </div>
    </div>
  )
};

const mapMethodsToProps = (apiService) => {
  return {
    getData: apiService.getProduct
  };
};

export default withApiService(mapMethodsToProps)(withData(OrderListCard))
